/**
 * Returns the ordered list of section IDs that should appear in the secondary bar nav,
 * based on the ad data — not on whether the panel component is mounted.
 *
 * Visibility rules (in order of precedence):
 *   PRICE       → always
 *   FEATURES    → always
 *   DESCRIPTION → only if ad has a description
 *   TRUST       → always
 *   ADVANTAGES  → only if at least one advantage card renders (see panels/advantages/getAdvantagesVisibility.js)
 *   FINANCING   → hidden for subscription/renting ads; otherwise only if financing data exists
 *   SELLER      → always
 */
const getVisibleAdDetailSectionIds = ({
  sectionsOrder,
  sectionIds,
  isDealerSubscription,
  showAdvantages,
  hasDescription,
  hasFinancing
}) => {
  return sectionsOrder.filter(id => {
    if (id === sectionIds.DESCRIPTION) return hasDescription
    if (id === sectionIds.ADVANTAGES) return showAdvantages
    if (id === sectionIds.FINANCING) return !isDealerSubscription && hasFinancing
    return true
  })
}

export default getVisibleAdDetailSectionIds
